import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-fluid formgrid grid" }
const _hoisted_2 = { class: "field col-12 lg:col-2" }
const _hoisted_3 = { class: "field col-12 lg:col-3" }
const _hoisted_4 = { class: "field col-12 lg:col-3" }
const _hoisted_5 = { class: "field col-12 lg:col-2" }
const _hoisted_6 = { class: "field col-12 lg:col-2 text-right" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { style: {"display":"block"} }, " ", -1)
const _hoisted_8 = {
  key: 0,
  class: "col-12"
}
const _hoisted_9 = {
  key: 1,
  class: "field col-12 text-right"
}
const _hoisted_10 = {
  key: 2,
  class: "col-12"
}
const _hoisted_11 = { class: "text-bold" }
const _hoisted_12 = {
  key: 3,
  class: "field col-12 text-right mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Column = _resolveComponent("Column")!
  const _component_ExaminationStateValue = _resolveComponent("ExaminationStateValue")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.handleSubmit()), ["prevent"])),
    onKeydown: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleKeydown($event)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", null, _toDisplayString(_ctx.t("statExaminationSchedule.period")), 1),
        _createVNode(_component_Calendar, {
          modelValue: _ctx.period,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.period) = $event)),
          selectionMode: "range",
          onDateSelect: _ctx.dataChanged
        }, null, 8, ["modelValue", "onDateSelect"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", null, _toDisplayString(_ctx.t("statExaminationSchedule.company")), 1),
        _createVNode(_component_Dropdown, {
          filter: true,
          options: _ctx.companies,
          optionLabel: "name",
          optionValue: "id",
          placeholder: "-",
          modelValue: _ctx.companyId,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.companyId) = $event)),
          onChange: _ctx.dataChanged
        }, null, 8, ["options", "modelValue", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", null, _toDisplayString(_ctx.t("statExaminationSchedule.doctor")), 1),
        _createVNode(_component_Dropdown, {
          filter: true,
          options: _ctx.doctors,
          optionLabel: "fullName",
          optionValue: "id",
          placeholder: "-",
          modelValue: _ctx.doctorId,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.doctorId) = $event)),
          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dataChanged()))
        }, null, 8, ["options", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("label", null, _toDisplayString(_ctx.t("statExaminationSchedule.state")), 1),
        _createVNode(_component_Dropdown, {
          options: [
            { value: 'all', label: _ctx.t('statExaminationSchedule.states.all') },
            { value: 'done', label: _ctx.t('statExaminationSchedule.states.done') },
          ],
          optionLabel: "label",
          optionValue: "value",
          placeholder: "-",
          modelValue: _ctx.state,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state) = $event))
        }, null, 8, ["options", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_Button, {
          label: _ctx.t('buttons.search'),
          icon: "pi pi-search",
          type: "submit",
          class: "p-button-primary p-uppercase"
        }, null, 8, ["label"])
      ]),
      (_ctx.showResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_Divider)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showResults && _ctx.results.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_Button, {
              label: _ctx.t('buttons.statExaminationSchedule.print'),
              icon: "pi pi-print",
              class: "p-button-primary p-uppercase",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.printPaper()))
            }, null, 8, ["label"]),
            _createVNode(_component_Button, {
              label: _ctx.t('buttons.statExaminationSchedule.printWithSignatures'),
              icon: "pi pi-print",
              class: "p-button-primary p-uppercase ml-4",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.printPaperWithSignatures()))
            }, null, 8, ["label"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_DataTable, {
              dataKey: "id",
              responsiveLayout: "scroll",
              showGridlines: "",
              sortField: "time",
              sortOrder: 1,
              stripedRows: "",
              value: _ctx.results
            }, {
              empty: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("gen.noData")), 1)
              ]),
              loading: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("gen.loading")), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "time",
                  header: _ctx.t('examination.datetime'),
                  headerStyle: "width: 12%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createTextVNode(_toDisplayString(_ctx.d(data[field], "shortDateTime")), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  sortField: "codeSort",
                  field: "code",
                  header: _ctx.t('examination.code'),
                  headerStyle: "width: 10%"
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(data.codeDisplay ?? "-"), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "branch",
                  header: _ctx.t('examination.companyAndBranch'),
                  headerStyle: "width: 18%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createTextVNode(_toDisplayString(data[field] ? `${data[field].company.name} - ${data[field].name}` : "-"), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "employee",
                  header: _ctx.t('examination.employee'),
                  headerStyle: "width: 18%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createTextVNode(_toDisplayString(data[field] ? data[field].fullName : "-"), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "doctor",
                  header: _ctx.t('examination.doctor'),
                  headerStyle: "width: 18%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createTextVNode(_toDisplayString(data[field] ? data[field].fullName : "-"), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "id",
                  header: _ctx.t('statExaminationSchedule.docs'),
                  bodyClass: "text-center",
                  headerStyle: "width: 12%"
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("span", {
                      class: _normalizeClass(`badge status-${data['healthRecordFile'] === undefined ? 'red' : 'green'}`)
                    }, "CS", 2),
                    _createElementVNode("span", {
                      class: _normalizeClass(`badge status-${data['companyJudgmentFile'] === undefined ? 'red' : 'green'} ml-2`)
                    }, "GD", 2),
                    _createElementVNode("span", {
                      class: _normalizeClass(`badge status-${data['employeeJudgmentFile'] === undefined ? 'red' : 'green'} ml-2`)
                    }, "GL", 2)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "state",
                  header: _ctx.t('examination.state'),
                  bodyClass: "text-center",
                  headerStyle: "width: 12%"
                }, {
                  body: _withCtx(({ data }) => [
                    _createVNode(_component_ExaminationStateValue, { examination: data }, null, 8, ["examination"])
                  ]),
                  _: 1
                }, 8, ["header"])
              ]),
              _: 1
            }, 8, ["value"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showResults && _ctx.results.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_Button, {
              label: "CS",
              icon: "pi pi-download",
              class: "p-button-primary p-uppercase",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.downloadFiles('healthRecordFile')))
            }),
            _createVNode(_component_Button, {
              label: "GD",
              icon: "pi pi-download",
              class: "p-button-primary p-uppercase ml-4",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.downloadFiles('companyJudgmentFile')))
            }),
            _createVNode(_component_Button, {
              label: "GL",
              icon: "pi pi-download",
              class: "p-button-primary p-uppercase ml-4",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.downloadFiles('employeeJudgmentFile')))
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ], 32))
}